import { Logtail } from "@logtail/browser";

const isLocalEnvironment = () => {
    const envValue = process.env.REACT_APP_IS_LOCAL_ENVIRONMENT;
    return ["true", "True", "TRUE", "1"].includes(envValue);
};

class ConsoleLogger {
    log(message, context) {
        console.log(message, context);
    }

    info(message, context) {
        console.info(message, context);
    }

    warn(message, context) {
        console.warn(message, context);
    }

    error(message, context) {
        console.error(message, context);
    }

    flush() {
        return Promise.resolve();
    }
}

const createLogger = () => {
    const token = process.env.REACT_APP_LOGTAIL_ATHENA_FRONTEND_SOURCE_TOKEN;

    if (isLocalEnvironment() || !token) {
        if (!token && !isLocalEnvironment()) {
            console.warn("REACT_APP_LOGTAIL_ATHENA_FRONTEND_SOURCE_TOKEN not found, falling back to console logger");
        }
        return new ConsoleLogger();
    }

    return new Logtail(token);
};

export const logger = createLogger();
